import { render, staticRenderFns } from "./file-lists.vue?vue&type=template&id=3188ca6c&scoped=true&"
import script from "./file-lists.vue?vue&type=script&lang=js&"
export * from "./file-lists.vue?vue&type=script&lang=js&"
import style0 from "./file-lists.vue?vue&type=style&index=0&id=3188ca6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3188ca6c",
  null
  
)

export default component.exports